var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTanks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311.8,
    height: 189.521,
    viewBox: "0 0 311.8 189.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.08;}.b{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1133.251 -179.468)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1133.251 261.102)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1445.051,236.045l-68.74-47.619-26.167,40.333-33.185-20.814h-55.616l-33.183,20.814-26.167-40.333-68.742,47.619,28.178,60.268h54.556l9.171-15.887h127.99l9.172,15.887h54.554Z",
    transform: "translate(-1133.25 -188.426)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1201.149 179.468)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1250.6,179.468h-43.79L1140.7,225.144l31.286,55.473,22.7-15.128h68.031l22.7,15.128,31.285-55.473Zm-21.407,67.493a25.558,25.558,0,1,1,25.554-25.563A25.566,25.566,0,0,1,1229.191,246.961Z",
    transform: "translate(-1140.701 -179.468)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTanks);
export default __webpack_public_path__ + "static/media/icon_tanks.11847c06e8cd0657e76b183ff084e7f7.svg";
export { ForwardRef as ReactComponent };